import { loadCartsFromCache as LoadCartCompanyFromCacheModule } from './load-carts-from-cache';

export async function loadCartCompanyFromCache(companyId: number, cacheName?: string) {
  const shoppingCartHash = btoa(`ShoppingCart:${companyId}`);
  const shoppingCarts = await LoadCartCompanyFromCacheModule(cacheName);
  return shoppingCarts.find((cart) => cart.id === shoppingCartHash);
}
